import React, { useState, useEffect, Fragment } from "react";
import { fetchAllExperiences } from "./api";
import { Select, Spin } from "antd";

function AgentExperienceTags({ agent, saveAgent, type, experienceType }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [experienceValues, setExperienceValues] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const { experience } = agent;

  useEffect(() => {
    async function fetchData() {
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const experienceValues = await fetchAllExperiences(experienceType);
      setExperienceValues(experienceValues);
      setLoading(false);
    }
    void fetchData();
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (tag) => {
    saveAgent({ experience: tag, agentId: agent.userId, experienceType });
  };

  return (
    <Fragment>
      <label>{type}</label>&nbsp;
      <div style={{ width: `100%` }}>
        <Spin spinning={loading}>
          <Select
            mode="multiple"
            data-testid="hcpDrawer-facility-types"
            style={{ width: `100%` }}
            placeholder={"Select " + type}
            defaultValue={
              experience
                ?.filter(({ type: extType }) => extType === experienceType)
                .map(({ _id }) => _id) || []
            }
            optionFilterProp="children"
            onChange={handleChange}
          >
            {experienceValues
              .filter(({ type: expType }) => expType === experienceType)
              .map((tag) => (
                <Select.Option key={tag._id} value={tag._id}>
                  {tag.name}
                </Select.Option>
              ))}
          </Select>
        </Spin>
      </div>
    </Fragment>
  );
}

export { AgentExperienceTags };
